const borders = {
  none: 0,
  '1px': '0.1rem #e5e7eb solid',
  '2px': '0.2rem #e5e7eb solid'
};

export default borders;
